import HttpStatusEventBus from "../httpStatusEventBus";
import { INTERNAL_SERVER_ERROR } from "http-status-codes";
import EventBus from "../../../../bus";
import { eventBus } from "../../../../plugins/event-bus";

function internalServerError() {
  HttpStatusEventBus.$on(INTERNAL_SERVER_ERROR.toString(), response => {
    let notification_credentials = {
      text: "server_error",
      color: "error",
      type: "error"
    };
    eventBus.$emit("snack-bar-notification", notification_credentials);
  });
}
export default internalServerError();
